// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:15
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class ComResult_abstract extends BaseObject {
  static $t: string = 'SagaBase.Defines.ComResult';
  $t: string = 'SagaBase.Defines.ComResult';

  public static GetMembers(): string[] {
    return ['ErrorMessage', 'ErrorCode', 'Result', 'Uid'];
  }

  public GetMembers(): string[] {
    return ComResult_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public ErrorMessage: string = '';
  public ErrorCode: number = 0;
  public Result: SagaBase.Defines.ComSendResult = SagaBase.Defines.ComSendResult.Ok;
  public Uid: Guid = GuidTools.Empty;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
